export const broadcast = {
  jobModuleRunning: 'Module "{{moduleName}}" has started.',
  jobModuleCompleted: 'Module "{{moduleName}}" is finished.',
  jobModuleFailed: 'Module "{{moduleName}}" has failed.',
};
